import React, {useEffect, useState} from 'react'
import PanelHead from '../../Panel/PanelHead'
import PanelBody from '../../Panel/PanelBody'
import { FormAddShop } from './FormAddShop'
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";
import {FormAddMembershipService} from "../../MembershipService/Add/FormAddMembershipService";

export const PanelAddShop = () => {
    const [isGroupsLoading, setIsGroupsLoading] = useState(true);
    const [groups, setGroups] = useState([]);

    const getGroups = async () => {
        setIsGroupsLoading(true);
        const {response} = await Helper.Get({
            url: api_Routes.MembershipGroup.ViewAll,
            hasToken: true,
        });
        if (response) {
            setGroups(response?.data);
        }
        setIsGroupsLoading(false);
    };

    useEffect(() => {
        getGroups();
    }, []);
    return (
        <div>  <PanelHead title='Add Advertising' />
            <PanelBody content={<FormAddShop  groups={groups} isGroupsLoading={isGroupsLoading} />} />
        </div>


    )
}
